import { useMemo } from 'react'
import { importacoesDetalhesColumns } from './columns/_columns'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { ImportacaoDetalhe } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useT } from '_metronic/i18n/Metronici18n'

export const ImportacaoDetalheListTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { t } = useT()

  const columns = useMemo(() => importacoesDetalhesColumns(t), [t])

  return (
    <CustomTable<ImportacaoDetalhe>
      id='kt_table_importacoes_detalhes'
      ariaLabel='Registros importados'
      itemLabel={{ singular: 'registro', plural: 'registros' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum registro importado'
          description='Nenhuma linha da planilha gerou atendimento. Veja os erros da importação.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
